import React from 'react';
import { Icon } from "semantic-ui-react";

function TheIcon (props) {
  return <Icon name="leanpub" {...props} />;
}

export const meta = {
  id: 'CMSPAGES',
  title: 'CMS Pages',
  category: 'CMS',
  exposes: [
    {
      title: 'CMS Pages',
      action: { module: 'CMSPAGES', props: { /* */ } },
    },
    {
      title: 'New Page',
      action: { module: 'CMSPAGESDetails', props: { context: 'add' } },
    },
    {
      title: 'CMS Redirects',
      action: { module: 'CMSRedirects', props: { /* */ } },
    },
    {
      title: 'New CMS Redirects',
      action: { module: 'CMSRedirectsDetails', props: { context: 'add' } },
    },
  ],
  unique: true,
  icon: TheIcon,
  version: '1.0.0',
  description: `Manages the pages of your website`,
  windowOptions: {
    // if not passed, will be centered
    x: 100,
    y: 100,
    width: 800,
    height: 500
  }
};
